(function() {

  class SortedList {
    constructor(element) {
      if(!element || element.classList.contains('u-module--initialized')) return;

      element.classList.add('u-module--initialized');

      this.element = element;
      this.init();
    }

    init() {
      const filterInputs = this.element.querySelectorAll('.u-sorted-list__filter-input');
      for (const filterInput of filterInputs) {
        filterInput.addEventListener('change', (e) => {
          if(e.currentTarget.checked) {
            this.filterItems(e.currentTarget.value);
          }
        });
      }
    }

    filterItems(filterTerm) {
      let isFollowingSingle = false;

      // remove first visible item class
      const currentFirstVisibleItems = this.element.querySelectorAll('.is-first-visible');
      for (const currentFirstVisibleItem of currentFirstVisibleItems) {
        currentFirstVisibleItem.classList.remove('is-first-visible');
      }
      // remove last visible item class
      const currentLastVisibleItems = this.element.querySelectorAll('.is-last-visible');
      for (const currentLastVisibleItem of currentLastVisibleItems) {
        currentLastVisibleItem.classList.remove('is-last-visible');
      }
      // remove last visible item class
      const isFollowingSingleItems = this.element.querySelectorAll('.is-following-single');
      for (const isFollowingSingleItem of isFollowingSingleItems) {
        isFollowingSingleItem.classList.remove('is-following-single');
      }
      // remove hidden item class
      const currentHiddenItems = this.element.querySelectorAll('.is-hidden');
      for (const currentHiddenItem of currentHiddenItems) {
        currentHiddenItem.classList.remove('is-hidden');
      }
      // add first visible item class
      const itemGroups = this.element.querySelectorAll('.u-sorted-list__group');
      for (const itemGroup of itemGroups) {
        let isFirstOfGroup = true;
        const items = itemGroup.querySelectorAll('.u-sorted-list__item');
        for (const item of items) {
          if(!filterTerm || (item.getAttribute('data-terms') || "").split(',').indexOf(filterTerm) >= 0) {
            if(isFirstOfGroup) {
              item.classList.add('is-first-visible');
              isFirstOfGroup = false;
            }
          } else {
            item.classList.add('is-hidden')
          }
        }

        const nonHiddenItems = itemGroup.querySelectorAll('.u-sorted-list__item:not(.is-hidden)');
        
        if(nonHiddenItems.length >= 1 && isFollowingSingle) {
          itemGroup.classList.add('is-following-single');
        }
        
        if(nonHiddenItems.length >= 1) {
          nonHiddenItems[nonHiddenItems.length - 1].classList.add('is-last-visible')
        }

        if (nonHiddenItems.length === 1 || (nonHiddenItems.length === 0 && isFollowingSingle)) {
          isFollowingSingle = true;
        } else {
          isFollowingSingle = false;
        }
      }
    }

  }

  function initAll(parent) {
    const elements = parent.querySelectorAll('.u-sorted-list');

    for (const element of elements) {
      new SortedList(element)
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('overlay-content-ready', function () {
    initAll(document.querySelector('.u-overlay__content'));
  });

})();